import React, { Component } from 'react';
import Quagga from 'quagga';
import './Style.css'; // Import the CSS file

class Scanner extends Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.state = {
      dataUri: ''
    };
    this._onDetected = this._onDetected.bind(this);
  }

  render() {
    const styles = {
      viewport: {
        position: 'relative',
        width: this.props.width || '100%',
        height: this.props.height || '100%',
        zIndex: 10, // Ensure the viewport has a higher z-index
      },
      canvas: {
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 20, // Ensure the canvas has a higher z-index
      }
    };
    return <div id="interactive" ref={this.videoRef} className="viewport" style={styles.viewport} />;
  }

  componentDidMount() {
    Quagga.init(
      {
        inputStream: {
          type: 'LiveStream',
          constraints: {
            width: { min: 800, max: 1280 },
            height: { min: 600, max: 720 },
            aspectRatio: { min: 4 / 3, max: 16 / 9 },
            facingMode: 'environment' // or user
          },
          area: {
            // defines rectangle of the detection/localization area
            top: '0%', // top offset
            right: '0%', // right offset
            left: '0%', // left offset
            bottom: '0%' // bottom offset
          }
        },
        frequency: 'full',
        locator: {
          patchSize: 'medium',
          halfSample: true
        },
        numOfWorkers: 4,
        decoder: {
          readers: [
            'code_39_vin_reader',
          ]
        },
        locate: true
      },
      function(err) {
        if (err) {
          return console.log(err);
        }
        Quagga.start();
      }
    );
    Quagga.onDetected(this._onDetected);
    Quagga.onProcessed(this._onProcessed);
  }

  componentWillUnmount() {
    Quagga.stop();
  }

  _onDetected(result) {
    let code = result;
    Quagga.stop();
    return this.props.handleScan(code);
  }

  _getMedian(arr) {
    arr.sort((a, b) => a - b);
    const half = Math.floor(arr.length / 2);
    if (arr.length % 2 === 1) {
      return arr[half];
    }
    return (arr[half - 1] + arr[half]) / 2.0;
  }

  _onProcessed(result) {
    let drawingCtx = Quagga.canvas.ctx.overlay,
      drawingCanvas = Quagga.canvas.dom.overlay;

    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(
          0,
          0,
          parseInt(drawingCanvas.getAttribute('width'), 10),
          parseInt(drawingCanvas.getAttribute('height'), 10)
        );
        result.boxes
          .filter(function(box) {
            return box !== result.box;
          })
          .forEach(function(box) {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: 'green',
              lineWidth: 2
            });
          });
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
          color: '#00F',
          lineWidth: 2
        });
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(
          result.line,
          { x: 'x', y: 'y' },
          drawingCtx,
          { color: 'red', lineWidth: 3 }
        );
      }
    }
  }
}

export default Scanner;
